export default "__VITE_PUBLIC_ASSET__f2bc5ea7__"